<template>
<div class="page page_fans page_adress">
    <div class="shaixuan-wrap">
        <div class="time-wrap">
            <div class="time-item" @click="showStartTime=true">{{ startTime ? startTime : '选择开始时间' }}</div>
            <div class="time-line">至</div>
            <div class="time-item" @click="showEndTime=true">{{ endTime ? endTime : '选择结束时间' }}</div>
        </div>
        <div class="ac-btn" @click="clickShaiXuan">筛选</div>
    </div>
	<div class="tongji-tips">总计：{{ saomalogNum }}</div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData">
        <div class="list">
            <div class="item" v-for="(item,index) in dataList" :key="index">
				<div class="item-t">
					<div class="item_l">
						<div class="user_name">绑定人：{{ item.agent_name }}</div>
					</div>
					<div class="item_r">{{ item.created_at }}</div>
				</div>
                <div class="qrcode-num">二维码编号：{{ item.qrcode_num }}</div>
            </div>
        </div>
    </van-list>
	<!-- 开始时间 -->
	<van-popup v-model="showStartTime" position="bottom">
		<van-datetime-picker v-model="currentDateStart" type="date" title="选择开始时间" :max-date="maxDate" @cancel="showStartTime=false" @confirm="confirmStartTime" />
	</van-popup>
	<!-- 结束时间 -->
	<van-popup v-model="showEndTime" position="bottom">
		<van-datetime-picker v-model="currentDateEnd" type="date" title="选择结束时间" :max-date="maxDate" @cancel="showEndTime=false" @confirm="confirmEndTime" />
	</van-popup>
</div>
</template>

<script>
export default {
    data() {
        return {
            token: null,
            page: 1,
            size: 10,
            dataList: [],
            loading: false,
            finished: false,
            uuid: null,
			startTime: null, // 开始时间
			currentDateStart: new Date(),
			maxDate: new Date(),
			showStartTime: false,
			startTimeDate: null,
			endTime: null, // 结束时间
			currentDateEnd: new Date(),
			endTimeDate: null,
			showEndTime: false,
			saomalogNum: 0 
        }
    },
    created() {
        this.token = this.$store.getters.token;
        this.uuid = this.$route.query.uuid;
		this.endTimeDate = new Date();
		let endTime = this.$util.getDateFun(this.endTimeDate);
		let oneDay = 24 * 60 * 60 * 1000;
		this.startTimeDate = new Date(Date.now() - 7*oneDay);
		let startTime = this.$util.getDateFun(this.startTimeDate);
		this.startTime = startTime.date;
		this.endTime = endTime.date;
    },
    methods: {
		/**
		 * @name: 筛选
		 * @return {*}
		 * @desc: 
		 */		
		clickShaiXuan(){
			if(!this.startTime){
				this.$toast('请选择开始时间');
				return;
			};
			if(!this.endTime){
				this.$toast('请选择结束时间');
				return;
			};
			if(this.endTimeDate < this.startTimeDate){
				this.$toast('结束时间不得小于开始时间');
				return;
			};
			this.page = 1;
			this.dataList = [];
			this.loading = true;
			this.finished = false;
			this.getData();
		},
		/**
		 * @name: 确认结束时间
		 * @param {*} val
		 * @return {*}
		 * @desc: 
		 */		
		confirmEndTime(val){
			this.endTimeDate = val;
			let dateObj = this.$util.getDateFun(val);
			this.endTime = dateObj.date;
			this.showEndTime = false;
		},
		/**
		 * @name: 确认开始时间
		 * @param {*} val
		 * @return {*}
		 * @desc: 
		 */		
		confirmStartTime(val){
			this.startTimeDate = val;
			let dateObj = this.$util.getDateFun(val);
			this.startTime = dateObj.date;
			this.showStartTime = false;
		},
        /**
         * @name: 获取记录
         * @return {*}
         * @desc: 
         */
        getData() {
            let params = {
                token: this.token,
                user_uuid: this.uuid,
                page: this.page,
                size: this.size
            };
			if(this.startTime){
				params.start_time = this.startTime;
			};
			if(this.endTime){
				params.end_time = this.endTime;
			};
            this.$api.salesman.saomalog(params).then(res => {
                if (res.code == 200) {
					this.saomalogNum = res.result.saomalog_num;
                    let list = res.result.saomalog;
                    if (list && list.length) {
                        for (let i in list) {
                            this.dataList.push(list[i]);
                        };
                        if (list.length < this.size) {
                            this.finished = true;
                        } else {
                            this.page++;
                            this.loading = false;
                        }
                    } else {
                        this.finished = true;
                    }
                } else {
                    this.finished = true;
                    this.$toast(res.message);
                }
            })
        },

    },
}
</script>

<style scoped>
.shaixuan-wrap {
    padding: .6rem .4rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.shaixuan-wrap .time-wrap {
    display: flex;
    align-items: center;
}

.shaixuan-wrap .time-wrap .time-item {
    width: 3rem;
    height: 0.8rem;
    border-radius: 0.4rem;
    text-align: center;
    line-height: 0.8rem;
    border: 0.0267rem solid #999999;
}

.shaixuan-wrap .time-wrap .time-line {
    padding: 0 .2rem;
}
.tongji-tips{
	padding: 0 .4rem;
}
.page_fans .list .item{
	display: block;
	padding: 0.4rem 0.53rem 0.4rem 0;
	height: auto;
}
.page_fans .list .item .item-t{
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.page_fans .list .item .user_name{
	max-width: 5rem;
}
.page_fans .list .item .qrcode-num{
	padding-top: .2rem;
	padding-left: .25rem;
}
</style>
